import { Paths } from '../constants/Paths';
export function buildInvoiceDetailsUrl(invoice) {
  const params = new URLSearchParams();
  params.set('invoiceId', String(invoice.objectId));
  params.set('invoiceNumber', invoice.invoiceNumber);
  if (invoice.invoiceLink) {
    params.set('url', invoice.invoiceLink);
  }
  if (invoice.downloadLink) {
    params.set('downloadUrl', invoice.downloadLink);
  }
  return `${Paths.INVOICE_DETAILS}?${params.toString()}`;
}
export function buildEmbeddedInvoiceUrl(invoiceUrl, parentOrigin) {
  try {
    const url = new URL(invoiceUrl);
    url.searchParams.set('notifyParentOnPaymentClick', 'true');
    url.searchParams.set('parentOrigin', parentOrigin);
    return url.toString();
  } catch (_unused) {
    return invoiceUrl;
  }
}
export function getSafeInvoiceDetailsPath(path, expectedOrigin) {
  if (!path) {
    return null;
  }
  try {
    const url = new URL(path, expectedOrigin);
    if (url.origin !== expectedOrigin || url.pathname !== Paths.INVOICE_DETAILS) {
      return null;
    }
    return `${url.pathname}${url.search}${url.hash}`;
  } catch (_unused2) {
    return null;
  }
}